export class SyncResponseLv {
    applicationUsers: boolean;
    dashboards: boolean;
    fieldTypes: boolean;
    lookUps: boolean;
    locations: boolean;
    jobTypes: boolean;
    jobScopes: boolean;
    jobStatuses: boolean;
    jobCommentDefaultLinkActionTypes: boolean;
    jobCommentDefaultGroups: boolean;
    jobCommentDefaults: boolean;
    jobCommentDefaultLinks: boolean;
    jobTypeHeaders: boolean;
    channels: boolean;
    jobTypeChannels: boolean;
    companies: boolean;
    job: boolean;
    unitPeriods: boolean;
    jobDailyReports: boolean;
    jobDailyReportHeaderValues: boolean;
    jobComments: boolean;
    unitPeriodChannelOffsets: boolean;
    unitPeriodChannels: boolean;
    syncDate: Date;
    syncMessage: string;
    isFailedJobSync?: boolean;
    isFailedCommonSync?: boolean;
}
